import React from 'react';
import PropTypes from 'prop-types';
import { Text, Pressable, View } from 'react-native';
import { Icon as RNVIcon } from 'renative';
import Theme from 'Theme';
import Icon from '../Icon';

import defaultStyles from './ButtonWithChildren.jss';

const ButtonWithChildren = ({
    onPress,
    iconName,
    title,
    subtitle,
    style,
    isSecondary,
    isDropdown,
    isToggled,
    isDisabled,
    ellipsizeMode,
    children
}) => (
    <Pressable
        disabled={isDisabled}
        style={[
            defaultStyles.button,
            isSecondary ? defaultStyles.secondaryButtonStyle : {},
            isDropdown ? defaultStyles.textContainerDropdown : {},
            style?.button,
            isDisabled && { opacity: 0.5 }
        ]}
        onPress={onPress}
    >
        {iconName && (
            <View style={defaultStyles.iconContainer}>
                <Icon name={iconName} style={[defaultStyles.icon, style?.icon]} />
            </View>
        )}
        <View
            style={[
                iconName ? defaultStyles.textContainer : defaultStyles.textContainerWithoutIcon,
                style?.textContainer
            ]}
        >
            <Text
                numberOfLines={1}
                ellipsizeMode={ellipsizeMode}
                style={[defaultStyles.text, style?.text]}
            >
                {title}
            </Text>
            {subtitle ? (
                <Text
                    numberOfLines={1}
                    ellipsizeMode={ellipsizeMode}
                    style={[defaultStyles.textSubtitle, style?.text]}
                >
                    {subtitle}
                </Text>
            ) : null}
        </View>
        {isDropdown && (
            <View style={defaultStyles.iconContainer}>
                <RNVIcon
                    iconFont="fontAwesome"
                    iconName={isToggled ? 'caret-up' : 'caret-down'}
                    iconColor={isToggled ? Theme.lightThemeTextColor : Theme.primaryTextColor}
                    style={{
                        ...defaultStyles.icon,
                        ...style?.icon
                    }}
                />
            </View>
        )}
        {children}
    </Pressable>
);

ButtonWithChildren.propTypes = {
    onPress: PropTypes.func,
    iconName: PropTypes.string,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    style: PropTypes.shape({}),
    isSecondary: PropTypes.bool,
    isDropdown: PropTypes.bool,
    isToggled: PropTypes.bool,
    isDisabled: PropTypes.bool,
    ellipsizeMode: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

ButtonWithChildren.defaultProps = {
    onPress: () => {},
    iconName: null,
    style: {},
    isSecondary: false,
    isDropdown: false,
    isToggled: false,
    isDisabled: false,
    ellipsizeMode: 'tail',
    subtitle: undefined,
    children: null
};

export default ButtonWithChildren;
